import React from "react";
import "./Styles.scss";

function SPVXVITargetPerformanceSection({}) {
  return (
    <div class="col-12">
      <div class="col-12">
        <div class="row ms-3 me-3">
          <div class="two-by-two-grid-new rounded horizontal-border-new">
            <div class="row border-between vertical-border-new">
              <div class="col-6 two-by-two-grid-item-new">
                {" "}
                <div class="fund-target-header-text-new">
                  2027 Revenue Projections
                </div>{" "}
                <span class="info-text-new">{"$30M ARR"}</span>
              </div>
              <div class="col-6 two-by-two-grid-item-new">
                {" "}
                <div class="fund-target-header-text-new">Strategy</div>{" "}
                <span class="info-text-new">Growth</span>
              </div>
            </div>
            <div class="row border-between">
              <div class="col-6 two-by-two-grid-item-new">
                <div class="fund-target-header-text-new">Robots deployed to date:</div>
                <span class="info-text-new">{"200+ robots"}</span>
              </div>
              <div class="col-6 two-by-two-grid-item-new">
                <div class="fund-target-header-text-new">
                  Minimum Investment
                </div>
                <span class="info-text-new">{"$25,000"}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0 mb-3">
          <div class="row gx-3"></div>
        </div>
      </div>
    </div>
  );
}
export default SPVXVITargetPerformanceSection;
